let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1bPSM")).then(() => parcelRequire('d7RpF'));